// @system — Branded 16:9 block shown where a post has no cover/thumbnail yet. Pure brand tokens
// (primary → surface → accent gradient) so it follows brand.json in both themes; decorative, so
// it is hidden from assistive tech (the card/article title carries the meaning).
import { cn } from '../../../../lib/@system/utils'

/**
 * @typedef {object} CoverPlaceholderProps
 * @property {string} [label]      Short text set large and faint in the corner (usually the category)
 * @property {string} [className]
 */

/** @param {CoverPlaceholderProps} props */
export function CoverPlaceholder({ label, className }) {
  return (
    <div
      aria-hidden="true"
      data-testid="cover-placeholder"
      className={cn(
        'relative aspect-video w-full overflow-hidden bg-gradient-to-br from-brand-primary/25 via-brand-surface to-brand-accent/25',
        className,
      )}
    >
      <div className="absolute -right-8 -top-8 h-40 w-40 rounded-full bg-brand-primary/20 blur-2xl" />
      <div className="absolute -bottom-10 -left-6 h-32 w-32 rounded-full bg-brand-accent/20 blur-2xl" />
      {label && (
        <span className="absolute bottom-3 left-4 text-xs font-semibold uppercase tracking-wider text-brand-text-muted/80">
          {label}
        </span>
      )}
    </div>
  )
}
